<template>
  <div>
    <headNavBar title="拆联" :fixed="true" />
    <div class="mt-header-nav">
      <h2 class="tip-info">
        将选中的房间拆联至一个新的订单中，新订单的渠道，价类，联系人等信息与本订单一致。如若变动请拆联后修改新的订单
      </h2>
      <van-checkbox-group
        v-model="checkedList"
        ref="checkboxGroup"
        class="check-box"
      >
        <van-checkbox
          v-for="room in roomList"
          :value="room.RoomInfoId"
          :name="room.RoomInfoId"
          :key="room.Id"
        >
          <p class="top-info">
            <span class="room-no"> {{ room.RoomNo }}</span>
            <span class="guest-room">
              客人姓名：{{ room.Persons[0].Name }}</span
            >
            <span class="room-status">
              <van-tag :color="room.OrderStatus == 1 ? '#87d068' : '#2db7f5'">
                {{ room.StatusName }}
              </van-tag>
            </span>
          </p>
          <p class="date">
            住离日期：{{ room.CheckInDate }} 至 {{ room.CheckOutDate }}
          </p>
        </van-checkbox>
      </van-checkbox-group>
      <van-goods-action>
        <template slot="default">
          <van-row style="width:100%">
            <van-col span="12">
              <van-button
                size="large"
                @click="
                  $router.push({ name: 'OrderDetail', query: { id: orderId } })
                "
              >
                取消
              </van-button>
            </van-col>
            <van-col span="12">
              <van-button type="info" size="large" @click="onSubmit">
                确定
              </van-button>
            </van-col>
          </van-row>
        </template>
      </van-goods-action>
    </div>
  </div>
</template>

<script>
import {
  Checkbox,
  CheckboxGroup,
  Button,
  GoodsAction,
  Row,
  Col,
  Notify,
  Tag,
  Dialog,
} from "vant";
import { mapState } from "vuex";
import orderApi from "../../api/order.js";
export default {
  components: {
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [Button.name]: Button,
    [GoodsAction.name]: GoodsAction,
    [Row.name]: Row,
    [Col.name]: Col,
    [Notify.name]: Notify,
    [Tag.name]: Tag,
  },
  computed: {
    ...mapState({
      user: state => state.user.info,
    }),
  },
  data() {
    return {
      checkedList: [],
      orderId: "",
      roomList: [],
      loading: false,
    };
  },
  created() {
    this.orderId = this.$route.query.id;
    this.getRoomNos();
  },
  methods: {
    onSubmit() {
      if (!this.checkedList.length) {
        Notify("请选择拆联的房号");
        return false;
      }
      if (this.checkedList.length == this.roomList.length) {
        Notify("不能将源订单的所有房间拆解至新的订单中！");
        return false;
      }
      let params = {
        SourceRoomInfoIds: this.checkedList,
        TargetOrderId: 0,
      };
      const _this = this;
      this.loading = true;
      Dialog.confirm({
        title: "确定拆联操作吗？",
      }).then(() => {
        orderApi.splitRoom(params).then(res => {
          Dialog.alert({
            message: res.Message,
          }).then(() => {
            _this.$router.push({
              name: "OrderDetail",
              query: { id: this.orderId },
            });
          });
        });
      });
    },
    getRoomNos() {
      this.roomList = [];
      orderApi
        .getOrderDetail({
          Id: this.orderId,
        })
        .then(res => {
          this.roomList = res.Data.Details.filter(el => {
            return el.OrderStatus == 0 || el.OrderStatus == 1;
          });
        });
    },
  },
};
</script>

<style lang="less">
.check-box {
  padding: 10px;
  font-size: 12px;
  .van-checkbox {
    margin-bottom: 10px;
    border-bottom: 1px solid #f3f3f3;
    padding-bottom: 10px;
  }
  .van-checkbox__label {
    width: 100%;
  }
  .top-info {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
  .date {
    color: #999;
  }
}
.tip-info {
  font-size: 12px;
  color: #ff7b00;
  padding: 3px 10px;
  background: #ffecc7;
  font-weight: normal;
}
</style>
